import { localTenantHosts } from "../features/tenant/localTenants";

type Props = {
  selectedHost: string;
  onChange: (host: string) => void;
};

export function LocalTenantSwitcher({ selectedHost, onChange }: Props) {
  return (
    <label class="tenant-switcher">
      <span>Local tenant</span>
      <select
        value={selectedHost}
        onChange={(event) => onChange(event.currentTarget.value)}
        aria-label="Local tenant"
      >
        {localTenantHosts.map((host) => (
          <option key={host} value={host}>
            {host}
          </option>
        ))}
      </select>
    </label>
  );
}
